import React from 'react';
import PropTypes from 'prop-types';

import { Container, Section, Row, Column, Group } from 'components/core/Page';
import { H2, H3, Text } from 'components/core/Typography';
import { Image } from 'components/core/Image';

import cityScapeDesktop from 'assets/images/landing/state-pages/city-scape-desktop.svg';

import './StatePagePlacesToLive.scss';

export default function StatePagePlacesToLive({ state, placesToLive }) {
	return (
		<div className="state-page-places-to-live">
			<Container className="places-to-live-container">
				<Section className="places-to-live-illustration">
					<Image src={cityScapeDesktop} />
				</Section>
				<div className="places-to-live-section">
					<Section>
						<H2
							size="medium"
							className="state-page-title"
						>
							Places to live in {state}
						</H2>
					</Section>
					<Section>
						<div
							className="places-to-live-copy"
							// eslint-disable-next-line react/no-danger
							dangerouslySetInnerHTML={{
								__html: placesToLive.copy,
							}}
						/>
					</Section>
					{placesToLive.cities.map(({ city, copy, facts }) => (
						<Section
							className="city-section"
							key={city}
						>
							<Group>
								<H3
									color="black"
									weight="bold"
									className="city"
								>
									{city}
								</H3>
							</Group>
							<Group>
								<div
									className="places-to-live-copy"
									// eslint-disable-next-line react/no-danger
									dangerouslySetInnerHTML={{ __html: copy }}
								/>
							</Group>
							{facts.map(({ item, value }) => (
								<Group
									className="city-fact-section"
									key={value}
								>
									<Row className="city-fact-row">
										<Column large={3}>
											<Text
												color="black"
												weight="light"
											>
												{item}
											</Text>
										</Column>
										<Column large={4}>
											<Text
												color="green"
												weight="light"
											>
												{value}
											</Text>
										</Column>
									</Row>
								</Group>
							))}
						</Section>
					))}
				</div>
			</Container>
		</div>
	);
}

StatePagePlacesToLive.propTypes = {
	state: PropTypes.string.isRequired,
	placesToLive: PropTypes.shape({
		copy: PropTypes.string,
		cities: PropTypes.arrayOf(
			PropTypes.shape({
				city: PropTypes.string,
				copy: PropTypes.string,
				facts: PropTypes.arrayOf(
					PropTypes.shape({
						item: PropTypes.string.isRequired,
						value: PropTypes.string.isRequired,
					}).isRequired,
				).isRequired,
			}).isRequired,
		).isRequired,
	}).isRequired,
};
